(() => {
  function init(root) {
    if (root.dataset.bestsellerReady) return;
    root.dataset.bestsellerReady = 'true';
    const $$ = selector => [...root.querySelectorAll(selector)];
    const board = root.querySelector('.life-board');
    const status = root.querySelector('[data-bestseller-light-status]');
    $$('[data-bestseller-light]').forEach(button => button.addEventListener('click', () => {
      const on = button.dataset.bestsellerLight === 'on';
      board.dataset.lit = String(on);
      $$('[data-bestseller-light]').forEach(item => item.setAttribute('aria-pressed', String((item.dataset.bestsellerLight === 'on') === on)));
      if (status) status.textContent = on ? 'Lights on' : 'Lights off';
    }));
    const colorViewer = root.querySelector('[data-bestseller-color-viewer]');
    if (colorViewer) {
      colorViewer.querySelectorAll('[data-bestseller-color]').forEach(button => button.addEventListener('click', () => {
        const color = button.dataset.bestsellerColor;
        colorViewer.querySelectorAll('[data-bestseller-color-image]').forEach(image => {
          const selected = image.dataset.bestsellerColorImage === color;
          image.classList.toggle('is-active', selected);
          image.setAttribute('aria-hidden', String(!selected));
        });
        colorViewer.querySelectorAll('[data-bestseller-color]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
    }
    const compare = root.querySelector('[data-bestseller-compare]');
    let syncCompareVariant = null;
    if (compare) {
      let nextRequest = 0;
      const levelButtons = [...compare.querySelectorAll('[data-bestseller-level]')];
      const viewButtons = [...compare.querySelectorAll('[data-bestseller-view]')];
      const colorButtons = [...compare.querySelectorAll('[data-bestseller-enhanced-choice]')];
      const panels = [...compare.querySelectorAll('[data-bestseller-angle]')];
      const colors = compare.querySelector('[data-bestseller-enhanced-controls]');
      const disneyImages = [...compare.querySelectorAll('[data-disney-image]')];
      const disneyChoices = [...compare.querySelectorAll('[data-disney-color-choice]')];
      const disneyControls = compare.querySelector('[data-disney-controls]');
      const live = compare.querySelector('[data-bestseller-compare-status]');
      async function selectCompare(level = compare.dataset.level, view = compare.dataset.view, color = compare.dataset.color || 'blue') {
        if (levelButtons.length && !levelButtons.some(button => button.dataset.bestsellerLevel === level)) return;
        if (!viewButtons.some(button => button.dataset.bestsellerView === view)) return;
        if (colorButtons.length && !colorButtons.some(button => button.dataset.bestsellerEnhancedChoice === color)) return;
        const panel = panels.find(item => item.dataset.bestsellerAngle === view);
        if (!panel) return;
        if (disneyImages.length) {
          if (!disneyChoices.some(button => button.dataset.disneyColorChoice === color)) return;
          const image = disneyImages.find(item => item.dataset.disneyImage === level + '-' + color);
          if (!image) return;
          const request = ++nextRequest;
          compare.setAttribute('aria-busy', 'true');
          try {
            await image.decode().catch(() => {
              if (!image.complete || !image.naturalWidth) throw Error('Comparison photo unavailable');
            });
          } catch {
            if (request === nextRequest) compare.removeAttribute('aria-busy');
            return;
          }
          if (request !== nextRequest) return;
          disneyImages.forEach(item => {
            const selected = item === image;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-hidden', String(!selected));
          });
          compare.dataset.level = level;
          compare.dataset.view = view;
          compare.dataset.color = color;
          levelButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bestsellerLevel === level)));
          viewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bestsellerView === view)));
          disneyChoices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.disneyColorChoice === color)));
          if (disneyControls) disneyControls.hidden = level !== 'standard';
          if (live) live.textContent = level === 'classic' ? 'Classic spotlights change color automatically' : 'Standard remote spotlight preview: ' + color;
          compare.removeAttribute('aria-busy');
          return;
        }
        const visible = [panel.querySelector('.gob-compare-base')];
        const layer = level === 'standard' ? panel.querySelector('[data-bestseller-layer="standard"]') :
          level === 'enhanced' ? panel.querySelector(colorButtons.length ? `[data-bestseller-enhanced-color="${color}"]` : '[data-bestseller-layer="enhanced"]') : null;
        if (layer) visible.push(layer);
        if (visible.some(image => !image)) return;
        const request = ++nextRequest;
        compare.setAttribute('aria-busy', 'true');
        try {
          await Promise.all(visible.map(image => image.decode().catch(() => {
            if (!image.complete || !image.naturalWidth) throw Error('Comparison photo unavailable');
          })));
        } catch {
          if (request === nextRequest) compare.removeAttribute('aria-busy');
          return;
        }
        if (request !== nextRequest) return;
        panels.forEach(item => {
          item.hidden = item !== panel;
          item.querySelectorAll('[data-bestseller-layer]').forEach(image => image.setAttribute('aria-hidden', String(item !== panel || image !== layer)));
        });
        compare.dataset.level = level;
        compare.dataset.view = view;
        if (colorButtons.length) compare.dataset.color = color;
        levelButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bestsellerLevel === level)));
        viewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bestsellerView === view)));
        colorButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bestsellerEnhancedChoice === color)));
        if (colors) colors.hidden = level !== 'enhanced';
        if (live) live.textContent = compare.hasAttribute('data-bestseller-color-versions') ? (level === 'classic' ? 'Classic / Standard, blue lighting' : 'Remote lighting, ' + color + ' base color') :
          root.dataset.set === '75379' ? (view === 'angle' ? 'Rear view' : 'Front view') :
          root.dataset.set === '21309' ? (view === 'angle' ? 'Separated stages' : 'Assembled view') :
          root.dataset.set === '76178' ? (view === 'side' ? 'Side view' : 'Front view') :
          root.dataset.set === '10312' && view === 'rear' ? 'Rear view' :
          root.dataset.set === '76344' ? (view === 'rear' ? 'Rear angle' : 'Front view') :
          `${level.charAt(0).toUpperCase() + level.slice(1)} lighting, ${view} view${level === 'enhanced' && colorButtons.length ? `, ${color} color` : ''}`;
        compare.removeAttribute('aria-busy');
      }
      levelButtons.forEach(button => button.addEventListener('click', () => selectCompare(button.dataset.bestsellerLevel)));
      viewButtons.forEach(button => button.addEventListener('click', () => selectCompare(compare.dataset.level, button.dataset.bestsellerView)));
      colorButtons.forEach(button => button.addEventListener('click', () => selectCompare('enhanced', compare.dataset.view, button.dataset.bestsellerEnhancedChoice)));
      disneyChoices.forEach(button => button.addEventListener('click', () => selectCompare('standard', compare.dataset.view, button.dataset.disneyColorChoice)));
      if (disneyImages.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const cycle = disneyChoices.map(button => button.dataset.disneyColorChoice);
        window.setInterval(() => {
          if (compare.dataset.level !== 'classic' || document.hidden) return;
          const index = cycle.indexOf(compare.dataset.color);
          selectCompare('classic', compare.dataset.view, cycle[(index + 1) % cycle.length]);
        }, 3600);
      }
      syncCompareVariant = title => {
        const level = compare.hasAttribute('data-bestseller-color-versions') ? (title === 'Remote' ? 'enhanced' : 'classic') :
          root.dataset.sameLights === 'true' ? 'classic' : root.dataset.set === '75367' ? (title === 'Classic' ? 'classic' : 'enhanced') :
          root.dataset.set === '42115' ? (title.startsWith('Classic') ? 'classic' : 'standard') :
          root.dataset.set === '10272' ? (title.startsWith('Classic') ? 'classic' : 'standard') :
          root.dataset.set === '71040' ? (title === 'Classic' ? 'classic' : 'standard') :
          root.dataset.set === '76344' ? 'classic' :
          title === 'Classic' ? 'classic' : title === 'Standard' ? 'standard' : 'enhanced';
        selectCompare(level);
      };
      selectCompare();
    }
    const included = root.querySelector('[data-gob-included-inline]');
    if (included) {
      let variants = [];
      try { variants = JSON.parse(included.querySelector('[data-gob-included-variants]').textContent); } catch {}
      const productRoot = document.querySelector('[data-gob-daylight]');
      const select = productRoot?.querySelector('[data-product-select]');
      const update = id => {
        const variant = variants.find(item => String(item.id) === String(id));
        if (variant && syncCompareVariant) syncCompareVariant(variant.title);
        const tab = variant?.tab || 0;
        included.querySelectorAll('[data-gob-included-tab]').forEach(panel => panel.hidden = Number(panel.dataset.gobIncludedTab) !== tab);
        const unknown = included.querySelector('[data-gob-included-unknown]');
        if (unknown) unknown.hidden = Boolean(tab);
        const live = included.querySelector('[data-gob-included-version]');
        if (live) live.textContent = variant?.title || '';
        included.querySelectorAll('[data-gob-included-version-id]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.gobIncludedVersionId === String(id))));
        const watch = root.querySelector('[data-bestseller-watch]');
        if (watch && root.dataset.set === '21335' && variant?.title) {
          const remote = variant.title !== 'Classic';
          watch.dataset.videoUrl = remote ? watch.dataset.bestsellerVideoRemote : watch.dataset.bestsellerVideoClassic;
        } else if (watch && root.dataset.set === '42115' && variant?.title) {
          watch.dataset.videoUrl = variant.title.startsWith('Classic') ? watch.dataset.bestsellerVideoClassic : watch.dataset.bestsellerVideoStandard;
        } else if (watch && variant?.video && !watch.hasAttribute('data-product-showcase')) watch.dataset.videoUrl = variant.video;
      };
      update(select?.value || variants[0]?.id);
      included.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.addEventListener('click', () => {
        const variant = variants.find(item => String(item.id) === button.dataset.gobIncludedVersionId);
        if (!variant) return;
        update(variant.id);
        const radio = [...(productRoot?.querySelectorAll('.d-v input[type="radio"]') || [])].find(item =>
          item.value === variant.title ||
          (root.dataset.productId === '6074027638944' && variant.title === 'RC + Sound' && item.value === 'Remote + Sound')
        );
        if (radio && !radio.disabled) radio.click();
      }));
      document.addEventListener('variant:change', event => {
        const variant = event.detail?.variant;
        if (variant && variants.some(item => String(item.id) === String(variant.id))) update(variant.id);
      });
      select?.addEventListener('change', () => update(select.value));
    }
    const dialog = root.querySelector('[data-bestseller-video-dialog]');
    const watch = root.querySelector('[data-bestseller-watch]');
    if (dialog && watch) {
      const container = dialog.querySelector('[data-bestseller-video-container]');
      const close = dialog.querySelector('[data-bestseller-video-close]');
      let opener = null;
      watch.addEventListener('click', () => {
        let url;
        try { url = new URL(watch.dataset.videoUrl); } catch { return; }
        if (!['youtube.com','www.youtube.com','youtu.be','www.youtube-nocookie.com'].includes(url.hostname)) return;
        const id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.pathname.startsWith('/embed/') ? url.pathname.split('/')[2] : url.searchParams.get('v');
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
        const frame = document.createElement('iframe');
        frame.title = 'Game of Bricks product video';
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        container.replaceChildren(frame);
        opener = watch;
        dialog.showModal();
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { container.replaceChildren(); opener?.focus({preventScroll:true}); });
    }
  }
  const start = () => document.querySelectorAll('[data-gob-bestseller-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
